import React, { useState } from 'react'
import { Alert, Form, Spinner } from 'react-bootstrap'
import '../../components/kyc/kycStyle.css'
import { validateIdNumber } from '../../utils/Validation'
import FooterButtons from '../../components/form/FooterButtons/FooterButtons'
import FormInput from '../../components/form/FormInput/FormInput'
import {
  API_ERROR_MESSAGE,
  INVALID_ID_WARNING,
  PRODUCT_ID,
  PRICELIST,
} from '../../utils/Constants'
import FormControlWithToolTip from '../../components/kyc/FormControlWithToolTip'
import {
  DownloadRealtimeReport,
  loadReport,
} from '../../api/realTimeIDV/realTimeIdv'
import { ReportTypes } from '../../api/apiConstants'
import { RESTRICTED_REPORT } from '../../utils/Constants'
import ScreenLayout from '../../components/layouts/ScreenLayout'
import { useMutation } from 'react-query'
import { onDownloadSuccess } from '../../api/shared/downloadFile'
import Notice from '../../components/Notice/Notice'
interface Props {
  setShow: (show: boolean) => void
  setIsError: (isError: boolean) => void
  setErrorMessage: (errorMessage: string) => void
  initialState: { [key: string]: any }
  KYCAccess: boolean
  setInitialState: React.Dispatch<React.SetStateAction<any>>
}
const RealTimeIdv: React.FC<Props> = ({
  setShow,
  setIsError,
  setErrorMessage,
  initialState,
  KYCAccess,
  setInitialState,
}) => {
  const [idNumber, setIdNumber] = useState('')
  const [reference, setReference] = useState('')
  const [showProgress, setShowProgress] = useState(false)

  const updateInitialState = () => {
    setInitialState({
      ...initialState,
      realTimeIdv: {
        idNumber: idNumber,
        reference: reference,
        price: PRICELIST.REALTIME_IDV,
      },
    })
  }
  const validateFields = () => {
    const missingFields = []
    if (!validateIdNumber(idNumber)) {
      missingFields.push('ID number')
    }
    return missingFields
  }

  const body = {
    productId: PRODUCT_ID,
    identityNumber: idNumber,
    reference: reference,
    reportType: ReportTypes.RealTimeIDVReport.reportTypeId,
  }
  const { mutate: loadRealtimeReport, isLoading: isDownloading } = useMutation(
    'loadRealtimeReport',
    async () => {
      try {
        const response = await loadReport({ body })
        const downloadBody = {
          reportType: ReportTypes.RealTimeIDVReport.reportTypeId,
          reportId: response.data.reportId,
        }
        const downloadResponse = await DownloadRealtimeReport({
          body: downloadBody,
        })
        if (downloadResponse) {
          onDownloadSuccess(downloadResponse)
        }
      } catch (error) {
        setIsError(true)
        setErrorMessage(API_ERROR_MESSAGE)
      }
    },
  )

  const handleSearch = async () => {
    const missingFields = validateFields()
    if (missingFields.length > 0) {
      return alert(
        'Please fill in the following fields: ' + missingFields.join(', '),
      )
    }
    setIsError(false)
    updateInitialState()
    loadRealtimeReport()
  }

  return (
    <ScreenLayout
      headerText={'Real Time ID Verification'}
      subHeaderText={'Home Affairs ID number Verification.'}
      price={PRICELIST.REALTIME_IDV}
      sampleReport={'IdVerification.pdf'}
    >
      {isDownloading && (
        <>
          <div className="spinner-container">
            <Spinner
              as="span"
              animation="border"
              variant="dark"
              role="status"
              aria-hidden="true"
            ></Spinner>
            <span> </span>
          </div>
        </>
      )}
      <Form.Group>
        <div className="mb-3">
          {KYCAccess !== true && <p className="lbl-red">{RESTRICTED_REPORT}</p>}
          <FormControlWithToolTip
            required
            onChangeHandler={setIdNumber}
            value={idNumber}
            placeHolderText="Unique identity number"
            toolTipText="Enter your unique Id number"
          />
        </div>
        {idNumber !== '' && !validateIdNumber(idNumber) ? (
          <Alert variant="danger" transition={false}>
            {INVALID_ID_WARNING}
          </Alert>
        ) : null}
        <FormInput
          className="mb-3"
          placeHolderText="Search reference (optional)"
          onChangeHandler={setReference}
          value={reference}
        />
        <FooterButtons
          handleSearch={handleSearch}
          setShow={setShow}
          isLoading={isDownloading}
        />
        {/* <Notice /> */}
      </Form.Group>
    </ScreenLayout>
  )
}

export default RealTimeIdv
